import React from 'react'
import { WorkSpaceUser } from '../../models'
import { Routes } from '../config/routes'
import { Redirect } from 'react-router-dom'
import { hasApplication } from '../../utils/applicationAccess'
import { APPLICATION_SLUGS } from '../../constants/applications'

interface OrganizationGuardProps {
    children: React.ReactNode
    workspaceUser?: WorkSpaceUser
}

export const OrganizationGuard = ({
    children,
    workspaceUser,
}: OrganizationGuardProps) => {
    if (!workspaceUser) {
        return <Redirect to={Routes.error.permissionDenied} />
    }

    if (!hasApplication(workspaceUser, APPLICATION_SLUGS.EZFOLIO)) {
        return (
            <Redirect
                to={{
                    pathname: Routes.error.applicationAccessDenied,
                    state: { applicationSlug: APPLICATION_SLUGS.EZFOLIO },
                }}
            />
        )
    }

    return <div>{children}</div>
}
